import { Action } from '@ngrx/store'

import * as RoleAction from '../../store/actions/role.action'
import { RoleCIF } from '../../shared/viewmodels/RegUtility';




export interface RoleState {
  readonly role: RoleCIF[];
}

// Section 1
const initialState: RoleState = {
  role: [{
    roleID: -1,
  }]

}

// Section 2

export function reducer(state: RoleState = initialState, action: RoleAction.RoleActions): RoleState {
  switch (action.type) {
    case RoleAction.ADD_ROLE:
      // Here, we need to update the 'name' array within the state object
      return {
        ...state,
        role: [...state.role, action.payload]
      };

    case RoleAction.REMOVE_ROLE:
      // Removing an item from the 'name' array within the state object
      return {
        ...state,
        role: state.role.filter((_, index) => index !== action.payload)
      };

    default:
      return state;
  }
}
